import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import { getRelationShip } from '../../redux/relationship/actions'
import { Alert, Modal, Form, Button, Row, Col, Card, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getBeneficers, 
         saveBeneficers, 
         editBeneficers, 
         deleteBeneficers } from '../../redux/securityBeneficers/actions'
import messages from '../../redux/messages'
import CustomTable from '../../components/CustomTable'
import config from '../../config'

const SecurityBeneficersComponent = (props, ref) => {

  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  //const [filter, setFilter] = useState('');

  const columns = [
    {
      Header: 'Identidad',
      accessor: 'identidad'
    },
    {
      Header: 'Nombre',
      accessor: 'nombre'
    },
    {
      Header: 'Teléfono',
      accessor: 'telefono'
    },
    {
      Header: 'Fecha de nacimiento',
      accessor: 'fecha_nacimiento',
      Filter: ''
    },
    {
      Header: 'Parentesco',
      //accessor: 'parentesco',
      Filter: '',
      Cell: value => {
        const parent = relationShip.find(item => item.id === value.row.original.parentesco);
        return parent ? parent.nombre : ''
        //return relationShip.length > 0 ? .nombre : '';
      }
    },
    {
      id: 'customButtons',
      Filter: '',
      Cell: value => (<div
        className="btn-group"
        role="group">
        <Button
          size="sm"
          variant="link"
          type="button"
          onClick={() => onEdit(value.row.original, value.row.index)}>
          <i className="material-icons">edit</i>
        </Button>
        <Button
          size="sm"
          className="text-danger"
          variant="link"
          type="button"
          onClick={() => onDelete(value.row.original.id, value.row.index)}>
          <i className="material-icons">close</i>
        </Button>
      </div>)
    }
  ];

  //Redux
  const dispatch = useDispatch();
  //EmerContact
  const loading = useSelector(store => store.beneficers.loading);
  const data = useSelector(store => store.beneficers.beneficers);
  //const dataLenght = useSelector(store => store.beneficers.beneficersLength);
  const saveBeneficersLoader = useSelector(store => store.beneficers.saveLoader);
  //RelationShip
  const relationShip = useSelector(store => store.relationship.relationShip);
  const relationShipLoader = useSelector(store => store.relationship.loading);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    setValidated(false);
  }

  useImperativeHandle(ref, () => ({
    onAdd
  }))

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    setValidated(false);
  }

  useEffect(() => {
    dispatch(getBeneficers({
      filter: props.id,
      empleado: props.id}, parseInt(props.type)));
  }, [dispatch, props.id, props.type]);
  
  
  useEffect(() => {
    dispatch(getRelationShip(parseInt(props.type)));
  }, [dispatch])

  const onSubmit = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const oData = {
      nombre: e.target.relativeName.value,
			identidad: e.target.relativeNIdentidad.value,
			telefono: e.target.relativePhone.value,
			direccion: e.target.relativeAddress.value,
			fecha_nacimiento: e.target.relativeBday.value,
			anotaciones: e.target.relativeAnt.value,
			genero: e.target.relativeGender.value,
			parentesco: parseInt(e.target.relativeRelationShip.value),
			empleado: parseInt(props.id)
    }

    if(edit){
      dispatch(editBeneficers(oData, editItem.id, index, parseInt(props.type)));
      setShowModal(false);
    }else{
      dispatch(saveBeneficers(oData, e.currentTarget, setValidated, parseInt(props.type)));
      //e.target.reset();
      //setShowModal(false);
    }
  }

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteBeneficers(id, index, parseInt(props.type)));
    }
  }

  const {genero} = config.aurora;

  return (
    <>
      {
        loading ? (
          <div className="d-flex justify-content-center">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center" />
          </div>
        ) : data.length > 0 ? (
          <>
            <Card className="border-0">
              <Card.Body className="px-1 px-sm-2">
                <CustomTable
                  columns={columns}
                  data={data} />
              </Card.Body>
            </Card>
          </>
        ) : (
          <Alert variant="info" className="my-4">
            Aún no hay familiares registrados para este empleado, comienza agregando algunos
          </Alert>
        )
      }
       <Modal
        show={showModal}
        size="lg"
        onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>{edit ? 'Editar ficha de familiar' : 'Crear ficha familiar'}</Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <Row>
              <Form.Group as={Col} controlId="relativeName">
                <Form.Label className="ml-2">Nombre completo</Form.Label>
                <Form.Control
                  name="relativeName"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[a-zA-Z][a-zA-Z\s]*"
                  defaultValue={edit ? editItem.nombre : null}
                  placeholder="Nombre completo"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="12" md="12" lg="4" controlId="relativeNIdentidad">
                <Form.Label className="ml-2">Identidad</Form.Label>
                <Form.Control
                  name="relativeNIdentidad"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[0-9]{13}"
                  defaultValue={edit ? editItem.identidad : null}
                  placeholder="Identidad"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite una cadena de números de longitud 13
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="12" md="12" lg="4" controlId="relativePhone">
                <Form.Label className="ml-2">Teléfono</Form.Label>
                <Form.Control
                  name="relativePhone"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[0-9]+"
                  defaultValue={edit ? editItem.telefono : null}
                  placeholder="Teléfono"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **ingrese un teléfono válido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} sm="12" md="12" lg="4" controlId="relativeBday">
                <Form.Label className="ml-2">Fecha de nacimiento</Form.Label>
                <Form.Control
                  name="relativeBday"
                  className="rounded-pill"
                  required
                  type="date"
                  defaultValue={edit ? editItem.fecha_nacimiento : null}
                  placeholder="Correo empresarial"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="relativeAnt">
                <Form.Label className="ml-2">Anotaciones</Form.Label>
                <Form.Control
                  name="relativeAnt"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[a-zA-Z0-9][a-zA-Z0-9\s]*"
                  defaultValue={edit ? editItem.anotaciones : null}
                  placeholder="Anotaciones"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="relativeGender">
                <Form.Label className="ml-2">Género</Form.Label>
                <Form.Control
                  as="select"
                  name="relativeGender"
                  className="rounded-pill"
                  required
                  defaultValue={ edit ? editItem.genero : null }
                  placeholder="Genero">
                    {
                      genero.map(item => (
                        <option key={item.id} value={item.id}>{item.nombre}</option>
                      ))
                    }
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="relativeShip">
                <Row className="align-items-end">
                  <Col sm={ relationShipLoader ? '10': '12' }>
                    <Form.Label className="ml-2">Parentesco</Form.Label>
                    <Form.Control
                      as="select"
                      name="relativeRelationShip"
                      className="rounded-pill"
                      required
                      defaultValue={ edit ? editItem.parentesco : null }
                      placeholder="Parentesco">
                        {
                          relationShip.map(item => (
                            <option key={item.id} value={item.id}>{item.nombre}</option>
                          ))
                        }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {
                    relationShipLoader && (
                      <Col sm="2">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Form.Group>
            </Row>
            <Form.Group controlId="relativeAddress">
              <Form.Label className="ml-2">Dirección</Form.Label>
              <Form.Control
                as="textarea"
                name="relativeAddress"
                required
                defaultValue={ edit ? editItem.direccion : null}
                pattern="[A-Za-z0-9]+"
                placeholder="Dirección"></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite números y letras
              </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
            <Button
              className="rounded-pill" 
              disabled={saveBeneficersLoader}  
              variant="primary" 
              type="submit">
                {
                  saveBeneficersLoader ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  ): null
                }
                Guardar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default forwardRef(SecurityBeneficersComponent)
